export default __webpack_public_path__ + "static/media/sphereSelected.147e3057.png";